import { AplosFile } from "../models/AplosFile";
import { AplosFileLineage } from "../models/AplosFileLineage";
import { AplosFileUploadFileTypes } from "./AplosFileUploadService";


// Centralized location for any AplosFile related calculations

export const isCleanedFile = (file: AplosFile): boolean => {
    return file?.lineage === AplosFileLineage.Cleaned;
}


export const isValidFileUploadType = (fileType: string): fileType is AplosFileUploadFileTypes => {
    return (Object.values(AplosFileUploadFileTypes) as string[]).includes(fileType)
}